/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HeaderMenu_manager = {
    readonly hasComplianceAccess: boolean;
    readonly company: {
        readonly name: string;
    };
    readonly " $refType": "HeaderMenu_manager";
};
export type HeaderMenu_manager$data = HeaderMenu_manager;
export type HeaderMenu_manager$key = {
    readonly " $data"?: HeaderMenu_manager$data;
    readonly " $fragmentRefs": FragmentRefs<"HeaderMenu_manager">;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "HeaderMenu_manager",
    "type": "Manager",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "hasComplianceAccess",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "company",
            "storageKey": null,
            "args": null,
            "concreteType": "Company",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "name",
                    "args": null,
                    "storageKey": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = '4777f325610bc52c920c0ce676b65132';
export default node;
